// // import { useEffect, useState } from "react";
// // import {
// //   Button,
// //   message,
// //   Table,
// //   Flex,
// //   Input,
// //   DatePicker,
// //   TreeSelect,
// //   Spin,
// //   Popconfirm,
// // } from "antd";
// // import {
// //   EditOutlined,
// //   DeleteOutlined,
// //   FolderOpenOutlined,
// // } from "@ant-design/icons";
// // import {
// //   fetchBuilders,
// //   deleteBuilder,
// // } from "../Service/qualityProcedureBuilder";
// // import { useNavigate } from "react-router-dom";
// // import dayjs from "dayjs";
// // import { fetchProduct } from "../../../../../configuration/module/Product/Service/product";
// // import { buildTreeData } from "../../../../../configuration/module/Product/Component/product";

// // const { RangePicker } = DatePicker;

// // const QualityProcedureBuilder = () => {
// //   const [builders, setBuilders] = useState([]);
// //   const [productList, setProductList] = useState([]);

// //   // pagination
// //   const [page, setPage] = useState(1);
// //   const [size, setSize] = useState(10);
// //   const [total, setTotal] = useState(0);

// //   // filters
// //   const [search, setSearch] = useState("");
// //   const [selectedProduct, setSelectedProduct] = useState(null);
// //   const [dateRange, setDateRange] = useState([]);

// //   // sorting
// //   const [sortField, setSortField] = useState("createdAt");
// //   const [sortOrder, setSortOrder] = useState("descend");

// //   const [loading, setLoading] = useState(false);

// //   const navigate = useNavigate();

// //   // ================= FETCH =================
// //   const fetchData = async (
// //     pageNum = page,
// //     pageSize = size,
// //     field = sortField,
// //     order = sortOrder
// //   ) => {
// //     setLoading(true);
// //     try {
// //       const res = await fetchBuilders({
// //         page: pageNum - 1,
// //         size: pageSize,
// //         search: search || undefined,
// //         product: selectedProduct || undefined,
// //         fromDate:
// //           dateRange?.length === 2
// //             ? dateRange[0].format("YYYY-MM-DD")
// //             : undefined,
// //         toDate:
// //           dateRange?.length === 2
// //             ? dateRange[1].format("YYYY-MM-DD")
// //             : undefined,
// //         sort: field,
// //         desc: order === "descend",
// //       });

// //       setBuilders(res.data?.content || res.data || []);
// //       setTotal(res.data?.totalElements || 0);
// //       setPage(pageNum);
// //       setSize(pageSize);
// //       setSortField(field);
// //       setSortOrder(order);
// //     } catch {
// //       message.error("Network error while fetching builders");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   // ================= INIT =================
// //   useEffect(() => {
// //     fetchData();

// //     fetchProduct()
// //       .then((res) => setProductList(buildTreeData(res.data)))
// //       .catch(() => message.error("Error fetching products"));
// //   }, []);

// //   // ================= ACTIONS =================
// //   const deleteData = async (id) => {
// //     try {
// //       await deleteBuilder(id);
// //       message.success("Quality Plan deleted successfully");
// //       fetchData(page, size);
// //     } catch {
// //       message.error("Error while deleting builder");
// //     }
// //   };

// //   const applyFilters = () => {
// //     fetchData(1, size);
// //   };

// //   const resetFilters = () => {
// //     setSearch("");
// //     setSelectedProduct(null);
// //     setDateRange([]);
// //     fetchData(1, size);
// //   };

// //   // ================= COLUMNS =================
// //   const columns = [
// //     {
// //       title: "ID",
// //       dataIndex: "id",
// //       key: "id",
// //       sorter: true,
// //       sortOrder: sortField === "id" ? sortOrder : null,
// //     },
// //     {
// //       title: "Procedure Name",
// //       dataIndex: "procedureName",
// //       key: "procedureName",
// //       sorter: true,
// //       sortOrder: sortField === "procedureName" ? sortOrder : null,
// //     },
// //     {
// //       title: "Product Name",
// //       dataIndex: "productName",
// //       key: "productName",
// //       sorter: true,
// //       sortOrder: sortField === "productName" ? sortOrder : null,
// //     },
// //     {
// //       title: "Created At",
// //       dataIndex: "createdAt",
// //       key: "createdAt",
// //       sorter: true,
// //       sortOrder: sortField === "createdAt" ? sortOrder : null,
// //       render: (val) => (val ? dayjs(val).format("DD MMM YYYY HH:mm") : "-"),
// //     },
// //     {
// //       title: "Updated At",
// //       dataIndex: "updatedAt",
// //       key: "updatedAt",
// //       sorter: true,
// //       sortOrder: sortField === "updatedAt" ? sortOrder : null,
// //       render: (val) => (val ? dayjs(val).format("DD MMM YYYY HH:mm") : "-"),
// //     },
// //     {
// //       title: "Actions",
// //       key: "actions",
// //       align: "center",
// //       render: (_, record) => (
// //         <>
// //           <FolderOpenOutlined
// //             style={{ marginRight: 12, cursor: "pointer" }}
// //             onClick={() => navigate(`view/${record.uuid}`)}
// //           />
// //           <EditOutlined
// //             style={{ marginRight: 12, cursor: "pointer" }}
// //             onClick={() => navigate(`edit/${record.uuid}`)}
// //           />
// //           <Popconfirm
// //             title="Delete Quality Plan"
// //             description="Are you sure you want to delete this Quality Plan?"
// //             okText="Yes"
// //             cancelText="No"
// //             okButtonProps={{ danger: true }}
// //             onConfirm={() => deleteData(record.uuid)}
// //           >
// //             <DeleteOutlined style={{ cursor: "pointer", color: "red" }} />
// //           </Popconfirm>
// //         </>
// //       ),
// //     },
// //   ];

// //   return (
// //     <Spin spinning={loading}>
// //       <div style={{ width: "100%" }}>
// //         <Flex
// //           justify="space-between"
// //           align="center"
// //           style={{ marginBottom: 16 }}
// //         >
// //           <div style={{ fontSize: "1rem", fontWeight: 700 }}>Quality Plan</div>
// //         </Flex>

// //         {/* Filters */}
// //         <Flex gap={12} style={{ marginBottom: 16, flexWrap: "wrap" }}>
// //           <Input
// //             placeholder="Search"
// //             value={search}
// //             onChange={(e) => setSearch(e.target.value)}
// //             style={{ width: 200 }}
// //           />

// //           <TreeSelect
// //             value={selectedProduct}
// //             onChange={setSelectedProduct}
// //             treeData={productList}
// //             placeholder="Select Product"
// //             allowClear
// //             style={{ width: 220 }}
// //           />

// //           <RangePicker value={dateRange} onChange={setDateRange} />

// //           <Button type="primary" onClick={applyFilters}>
// //             Apply
// //           </Button>
// //           <Button onClick={resetFilters}>Reset</Button>

// //           <Flex flex={1} justify="flex-end">
// //             <Button type="primary" onClick={() => navigate("add")}>
// //               Add
// //             </Button>
// //           </Flex>
// //         </Flex>

// //         {/* Table */}
// //         <Table
// //           rowKey="uuid"
// //           columns={columns}
// //           dataSource={builders}
// //           bordered
// //           scroll={{ x: "max-content" }}
// //           pagination={{
// //             current: page,
// //             pageSize: size,
// //             total,
// //             showSizeChanger: true,
// //             pageSizeOptions: ["10", "20", "50", "100"],
// //           }}
// //           onChange={(pagination, filters, sorter) => {
// //             const field = sorter.field || sortField;
// //             const order = sorter.order || sortOrder;

// //             fetchData(pagination.current, pagination.pageSize, field, order);
// //           }}
// //         />
// //       </div>
// //     </Spin>
// //   );
// // };

// // export default QualityProcedureBuilder;
// import { useEffect, useState } from "react";
// import {
//   Button,
//   message,
//   Table,
//   Flex,
//   Input,
//   DatePicker,
//   TreeSelect,
//   Spin,
//   Popconfirm,
// } from "antd";
// import {
//   EditOutlined,
//   DeleteOutlined,
//   FolderOpenOutlined,
// } from "@ant-design/icons";
// import {
//   fetchBuilders,
//   deleteBuilder,
// } from "../Service/qualityProcedureBuilder";
// import { useNavigate } from "react-router-dom";
// import dayjs from "dayjs";
// import { fetchProduct } from "../../../../../configuration/module/Product/Service/product";
// import { buildTreeData } from "../../../../../configuration/module/Product/Component/product";

// const { RangePicker } = DatePicker;

// let searchTimeout = null;

// const QualityProcedureBuilder = () => {
//   const [builders, setBuilders] = useState([]);
//   const [productList, setProductList] = useState([]);

//   // pagination
//   const [page, setPage] = useState(1);
//   const [size, setSize] = useState(10);
//   const [total, setTotal] = useState(0);

//   // filters
//   const [search, setSearch] = useState("");
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [dateRange, setDateRange] = useState([]);

//   // sorting
//   const [sortField, setSortField] = useState("createdDate");
//   const [sortOrder, setSortOrder] = useState("descend");

//   const [loading, setLoading] = useState(false);

//   const navigate = useNavigate();

//   // ================= FETCH =================
//   const fetchData = async (
//     pageNum = page,
//     pageSize = size,
//     field = sortField,
//     order = sortOrder,
//     searchText = search,
//     productFilter = selectedProduct,
//     dateRangeFilter = dateRange
//   ) => {
//     setLoading(true);
//     try {
//       const res = await fetchBuilders({
//         page: pageNum - 1,
//         size: pageSize,
//         search: searchText || undefined,
//         product: productFilter || undefined,
//         fromDate:
//           dateRangeFilter?.length === 2
//             ? dateRangeFilter[0].format("YYYY-MM-DD")
//             : undefined,
//         toDate:
//           dateRangeFilter?.length === 2
//             ? dateRangeFilter[1].format("YYYY-MM-DD")
//             : undefined,
//         sort: field,
//         desc: order === "descend",
//       });

//       setBuilders(res.data?.content || res.data || []);
//       setTotal(res.data?.totalElements || 0);
//       setPage(pageNum);
//       setSize(pageSize);
//       setSortField(field);
//       setSortOrder(order);
//     } catch {
//       message.error("Network error while fetching builders");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ================= DELETE =================
//   const deleteData = async (id) => {
//     try {
//       await deleteBuilder(id);
//       message.success("Quality Plan deleted successfully");
//       fetchData(page, size, sortField, sortOrder); // refresh after delete
//     } catch {
//       message.error("Error while deleting builder");
//     }
//   };

//   // ================= FILTERS =================
//   const applyFilters = () => {
//     fetchData(
//       1,
//       size,
//       sortField,
//       sortOrder,
//       search,
//       selectedProduct,
//       dateRange
//     );
//   };

//   const resetFilters = () => {
//     setSearch("");
//     setSelectedProduct(null);
//     setDateRange([]);
//     fetchData(1, size, sortField, sortOrder);
//   };

//   // ================= INIT =================
//   useEffect(() => {
//     fetchData(); // initial fetch
//     fetchProduct()
//       .then((res) => setProductList(buildTreeData(res.data)))
//       .catch(() => message.error("Error fetching products"));
//   }, []);

//   // ================= SEARCH (DEBOUNCE) =================
//   useEffect(() => {
//     clearTimeout(searchTimeout);
//     searchTimeout = setTimeout(() => {
//       fetchData(1, size, sortField, sortOrder, search);
//     }, 500);

//     return () => clearTimeout(searchTimeout);
//   }, [search]);

//   // ================= COLUMNS =================
//   const columns = [
//     {
//       title: "ID",
//       dataIndex: "id",
//       key: "id",
//       sorter: true,
//       sortOrder: sortField === "id" ? sortOrder : null,
//     },
//     {
//       title: "Procedure Name",
//       dataIndex: "procedureName",
//       key: "procedureName",
//       sorter: true,
//       sortOrder: sortField === "procedureName" ? sortOrder : null,
//     },
//     {
//       title: "Product Name",
//       dataIndex: "productName",
//       key: "productName",
//       sorter: true,
//       sortOrder: sortField === "productName" ? sortOrder : null,
//     },
//     {
//       title: "Created date",
//       dataIndex: "createdDate",
//       key: "createdDate",
//       sorter: true,
//       sortOrder: sortField === "createdAt" ? sortOrder : null,
//       render: (val) => (val ? dayjs(val).format("DD MMM YYYY HH:mm") : "-"),
//     },
//     {
//       title: "Updated At",
//       dataIndex: "updatedAt",
//       key: "updatedAt",
//       sorter: true,
//       sortOrder: sortField === "updatedAt" ? sortOrder : null,
//       render: (val) => (val ? dayjs(val).format("DD MMM YYYY HH:mm") : "-"),
//     },
//     {
//       title: "Actions",
//       key: "actions",
//       align: "center",
//       render: (_, record) => (
//         <>
//           <FolderOpenOutlined
//             style={{ marginRight: 12, cursor: "pointer" }}
//             onClick={() => navigate(`view/${record.uuid}`)}
//           />
//           <EditOutlined
//             style={{ marginRight: 12, cursor: "pointer" }}
//             onClick={() => navigate(`edit/${record.uuid}`)}
//           />
//           <Popconfirm
//             title="Delete Quality Plan"
//             description="Are you sure you want to delete this Quality Plan?"
//             okText="Yes"
//             cancelText="No"
//             placement="left"
//             okButtonProps={{ danger: true }}
//             onConfirm={() => deleteData(record.uuid)}
//           >
//             <DeleteOutlined style={{ cursor: "pointer", color: "red" }} />
//           </Popconfirm>
//         </>
//       ),
//     },
//   ];

//   // ================= RENDER =================
//   return (
//     <Spin spinning={loading}>
//       <div style={{ width: "100%" }}>
//         <div style={{ fontSize: "1rem", fontWeight: 700, marginBottom: 16 }}>
//           Quality Plan
//         </div>

//         {/* Filters */}
//         <Flex gap={12} style={{ marginBottom: 16, flexWrap: "wrap" }}>
//           <Input
//             placeholder="Search"
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             style={{ width: 200 }}
//           />

//           <TreeSelect
//             value={selectedProduct}
//             onChange={setSelectedProduct}
//             treeData={productList}
//             placeholder="Select Product"
//             allowClear
//             style={{ width: 220 }}
//           />

//           <RangePicker value={dateRange} onChange={setDateRange} />

//           <Button type="primary" onClick={applyFilters}>
//             Apply
//           </Button>
//           <Button onClick={resetFilters}>Reset</Button>

//           <Flex flex={1} justify="flex-end">
//             <Button type="primary" onClick={() => navigate("add")}>
//               Add
//             </Button>
//           </Flex>
//         </Flex>

//         {/* Table */}
//         <Table
//           rowKey="uuid"
//           columns={columns}
//           dataSource={builders}
//           bordered
//           scroll={{ x: "max-content" }}
//           pagination={{
//             current: page,
//             pageSize: size,
//             total,
//             showSizeChanger: true,
//             pageSizeOptions: ["10", "20", "50", "100"],
//           }}
//           onChange={(pagination, filters, sorter) => {
//             const field = sorter.field || sortField;
//             const order = sorter.order || sortOrder;

//             fetchData(
//               pagination.current,
//               pagination.pageSize,
//               field,
//               order,
//               search,
//               selectedProduct,
//               dateRange
//             );
//           }}
//         />
//       </div>
//     </Spin>
//   );
// };

// export default QualityProcedureBuilder;

import { useEffect, useState } from "react";
import { Button, message, Table, Flex, Input, DatePicker, TreeSelect, Spin, Popconfirm } from "antd";
import { EditOutlined, DeleteOutlined, FolderOpenOutlined } from "@ant-design/icons";
import { fetchBuilders, deleteBuilder } from "../Service/qualityProcedureBuilder";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { fetchProduct } from "../../../../../configuration/module/Product/Service/product";
import { buildTreeData } from "../../../../../configuration/module/Product/Component/product";
import usePermission from "../../../../../hooks/usePermission";

const { RangePicker } = DatePicker;

const QualityProcedureBuilder = () => {
  const { canCreate, canUpdate, canDelete } = usePermission("QUALITY_TEMPLATE");
  const navigate = useNavigate();

  const [builders, setBuilders] = useState([]);
  const [productList, setProductList] = useState([]);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [dateRange, setDateRange] = useState([]);
  const [sortField, setSortField] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("descend");
  const [loading, setLoading] = useState(false);

  const fetchData = async (pageNum = page, pageSize = size, field = sortField, order = sortOrder, searchText = search, product = selectedProduct, range = dateRange) => {
    setLoading(true);
    try {
      const res = await fetchBuilders({
        page: pageNum - 1, size: pageSize,
        search: searchText || undefined,
        productId: product || undefined,
        fromDate: range?.length === 2 ? range[0] : undefined,
        toDate: range?.length === 2 ? range[1] : undefined,
        sort: field, desc: order === "descend",
      });
      setBuilders(res.data?.content || []);
      setTotal(res.data?.totalElements || 0);
      setPage(pageNum); setSize(pageSize); setSortField(field); setSortOrder(order);
    } catch { message.error("Error fetching quality plans"); }
    finally { setLoading(false); }
  };

  useEffect(() => {
    fetchData();
    fetchProduct().then((res) => setProductList(buildTreeData(res.data))).catch(() => message.error("Error fetching products"));
  }, []);

  const deleteData = async (uuid) => {
    try {
      await deleteBuilder(uuid);
      message.success("Quality Plan deleted successfully");
      fetchData();
    } catch { message.error("Error deleting quality plan"); }
  };

  const applyFilters = () => fetchData(1, size, sortField, sortOrder, search, selectedProduct, dateRange);
  const resetFilters = () => {
    setSearch(""); setSelectedProduct(null); setDateRange([]);
    fetchData(1, size, sortField, sortOrder, "", null, []);
  };

  const columns = [
    { title: "Checklist Name", dataIndex: "checklistName", key: "checklistName", sorter: true, sortOrder: sortField === "checklistName" ? sortOrder : null },
    { title: "Product Name", dataIndex: "productName", key: "productName", sorter: true },
    { title: "Created date", dataIndex: "createdDate", key: "createdDate", sorter: true, render: (val) => (val ? dayjs(val).format("DD MMM YYYY HH:mm") : "-") },
    { title: "Updated At", dataIndex: "updatedAt", key: "updatedAt", sorter: true, render: (val) => (val ? dayjs(val).format("DD MMM YYYY HH:mm") : "-") },
    {
      title: "Actions", key: "actions", align: "center",
      render: (_, record) => (
        <>
          <FolderOpenOutlined style={{ marginRight: 12, cursor: "pointer" }} onClick={() => navigate(`view/${record.uuid}`)} />
          {canUpdate && <EditOutlined style={{ marginRight: 12, cursor: "pointer" }} onClick={() => navigate(`edit/${record.uuid}`)} />}
          {canDelete && (
            <Popconfirm title="Delete Quality Plan" description="Are you sure?" okText="Yes" cancelText="No" placement="left" okButtonProps={{ danger: true }} onConfirm={() => deleteData(record.uuid)}>
              <DeleteOutlined style={{ cursor: "pointer", color: "red" }} />
            </Popconfirm>
          )}
        </>
      ),
    },
  ];

  return (
    <Spin spinning={loading}>
      <div style={{ width: "100%" }}>
        <div style={{ fontSize: "1rem", fontWeight: 700, marginBottom: 16 }}>Quality Plan</div>
        <Flex gap={12} style={{ marginBottom: 16, flexWrap: "wrap" }}>
          <Input placeholder="Search" value={search} onChange={(e) => setSearch(e.target.value)} style={{ width: 200 }} />
          <TreeSelect value={selectedProduct} onChange={setSelectedProduct} treeData={productList} placeholder="Select Product" allowClear style={{ width: 220 }} />
          <RangePicker value={dateRange} onChange={setDateRange} />
          <Button type="primary" onClick={applyFilters}>Apply</Button>
          <Button onClick={resetFilters}>Reset</Button>
          {canCreate && (
            <Flex flex={1} justify="flex-end">
              <Button type="primary" onClick={() => navigate("add")}>Add</Button>
            </Flex>
          )}
        </Flex>
        <Table rowKey="uuid" columns={columns} dataSource={builders} bordered scroll={{ x: "max-content" }}
          pagination={{ current: page, pageSize: size, total, showSizeChanger: true, pageSizeOptions: ["10", "20", "50", "100"] }}
          onChange={(pagination, _, sorter) => fetchData(pagination.current, pagination.pageSize, sorter.field || sortField, sorter.order || sortOrder, search, selectedProduct, dateRange)}
        />
      </div>
    </Spin>
  );
};

export default QualityProcedureBuilder;